// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__2PDx8","rotate":"loader_rotate__0ZM8V","loaderCircle":"loader_loaderCircle__sAK2B","dash":"loader_dash__uTjf9"};